import { safeHTML } from '../../../../utils/safeHTML';
import React from 'react';
import { useModifiedDescription } from '../../../../hooks/shared/quests/useModifiedDescription';

export default function TaskItemText({ quest }) {
  const modifiedDescription = useModifiedDescription({ quest });
  return <p className={'task__item-text'}>{safeHTML(modifiedDescription)}</p>;
}
